export default __webpack_public_path__ + "static/media/prev-airstrapz.5dcb36e6.jpg";